/* tslint:disable */
/* eslint-disable */
/**
 * Melco Tracking APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TrackingMelcoAnalyticsModelsAvailabilityStatusListItem,
    TrackingMelcoAnalyticsModelsAvailabilityStatusListItemFromJSON,
    TrackingMelcoAnalyticsModelsAvailabilityStatusListItemFromJSONTyped,
    TrackingMelcoAnalyticsModelsAvailabilityStatusListItemToJSON,
    TrackingMelcoModelsCustomWarning,
    TrackingMelcoModelsCustomWarningFromJSON,
    TrackingMelcoModelsCustomWarningFromJSONTyped,
    TrackingMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface TrackingMelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityStatusListItem
 */
export interface TrackingMelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityStatusListItem {
    /**
     * 
     * @type {Array<TrackingMelcoAnalyticsModelsAvailabilityStatusListItem>}
     * @memberof TrackingMelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityStatusListItem
     */
    list: Array<TrackingMelcoAnalyticsModelsAvailabilityStatusListItem>;
    /**
     * 
     * @type {Array<TrackingMelcoModelsCustomWarning>}
     * @memberof TrackingMelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityStatusListItem
     */
    warning_list?: Array<TrackingMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof TrackingMelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityStatusListItem
     */
    total: number;
}

export function TrackingMelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityStatusListItemFromJSON(json: any): TrackingMelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityStatusListItem {
    return TrackingMelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityStatusListItemFromJSONTyped(json, false);
}

export function TrackingMelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityStatusListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackingMelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityStatusListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(TrackingMelcoAnalyticsModelsAvailabilityStatusListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(TrackingMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function TrackingMelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityStatusListItemToJSON(value?: TrackingMelcoModelsGenericList1MelcoAnalyticsModelsAvailabilityStatusListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(TrackingMelcoAnalyticsModelsAvailabilityStatusListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(TrackingMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


